<template>
  <div class="social-groups-wrapper w-100" dir="rtl">
    <!-- حلقه روی دسته‌های گروه‌بندی شده -->
    <div 
      v-for="(group, index) in displayedGroups" 
      :key="group.name"
      class="group-card glass-effect elevation-2 pa-1"
    >
      <div class="group-header">
        <div class="color-indicator" :style="{ background: group.color }"></div>
        <div class="main-icon-wrapper">
          <!-- اصلاح نحوه ارسال viewBox به فرمت استاندارد SVG -->
          <svg-base :view-box="`0 0 ${group.viewBox} ${group.viewBox}`">
            <component :is="group.svg" :style="{ fill: group.color }" />
          </svg-base>
        </div>
      </div>
      <div class="group-links">
        <a
          v-for="(link, i) in group.items"
          :key="i"
          class="link-item"
          @click="$emit('go-to-url', link.url, link.pattern)"
        >
          <span class="link-text" dir="ltr">{{ link.url || link.label }}</span>
        </a>
      </div>
    </div>

    <!-- دکمه نمایش بیشتر / کمتر -->
    <div v-if="groupedMediasArray.length > initialLimit" class="toggle-container w-100 mt-2">
      <div class="divider-line"></div>
      <button class="toggle-btn glass-effect" @click="isListExpanded = !isListExpanded">
        <v-icon small color="white" class="mr-1">
          {{ isListExpanded ? 'mdi-chevron-up' : 'mdi-chevron-down' }}
        </v-icon>
        <span>{{ isListExpanded ? 'نمایش کمتر' : 'نمایش بیشتر' }}</span>
      </button>
      <div class="divider-line"></div>
    </div>
  </div>
</template>

<script>
const socialConfig = {
  aparat: { svg: "svgAparat", color: "#ed145b", viewBox: 50 },
  eitaa: { svg: "svgEitaa", color: "#e88214", viewBox: 50 },
  soroush: { svg: "svgSoroush", color: "#26758e", viewBox: 50 },
  bale: { svg: "svgBale", color: "#355d84", viewBox: 50 },
  rubika: { svg: "svgRubika", color: "#c7c7c7", viewBox: 50 },
  gap: { svg: "svgGap", color: "#744ccf", viewBox: 50 },
  instagram: { svg: "svgInstagram", color: "#cc39a4", viewBox: 50 },
  whatsapp: { svg: "svgWhatsapp", color: "#40c351", viewBox: 50 },
  linkedin: { svg: "svgLinkedin", color: "#0288D1", viewBox: 50 },
  linkedin_company: { svg: "svgLinkedinCo", color: "#0076B5C7", viewBox: 50 },
  telegram: { svg: "svgTelegram", color: "#29b6f6", viewBox: 50 },
  pinterest: { svg: "svgPinterest", color: "#E60023", viewBox: 50 },
  dribbble: { svg: "svgDribbble", color: "#ed3675", viewBox: 50 },
  facebook: { svg: "svgFacebook", color: "#448AFF", viewBox: 50 },
  github: { svg: "svgGithub", color: "#161414", viewBox: 50 },
  threads: { svg: "svgThreads", color: "#000", viewBox: 50 },
  tiktok: { svg: "svgTiktok", color: "#212121", viewBox: 50 },
  twitter: { svg: "svgTwitter", color: "#03A9F4", viewBox: 50 },
  skype: { svg: "svgSkype", color: "#03A9F4", viewBox: 50 },
  youtube: { svg: "svgYoutube", color: "#FF0000", viewBox: 50 },
  wechat: { svg: "svgWechat", color: "#8BC34A", viewBox: 50 },
  viber: { svg: "svgViber", color: "#7E57C2", viewBox: 50 },
  divar: { svg: "svgDivar", color: "#a62626", viewBox: 50 },
  sheypoor: { svg: "svgSheypour", color: "#0073f3", viewBox: 50 },  
  digikala: { svg: "svgDigikala", color: "#ef394e", viewBox: 880 },
  torob: { svg: "svgTorob", color: "#d62020", viewBox: 200 },
  email: { svg: "svgEmail", color: "#2196F3", viewBox: 50 },
  address: { svg: "svgLocation", color: "#90caf9", viewBox: 50 },
  snappshop: { svg: "svgSnappshop", color: "#B400AE", viewBox: 50 },
  technolife: { svg: "svgTechnolife", color: "#26487e", viewBox: 50 },
  emalls: { svg: "svgEmalls", color: "#fd564a", viewBox: 280 },
  cafebazaar: { svg: "svgCafebazaar", color: "#5BEA3B", viewBox: 300 },
  googleplay: { svg: "svgGoogleplay", color: "#1394FE", viewBox: 50 },
  samsung: { svg: "svgSamsung", color: "#ec3c75", viewBox: 50 },
  apple: { svg: "svgApple", color: "#2494f4", viewBox: 50 },
  basalam: { svg: "svgBasalam", color: "#FF5C39", viewBox: 100 }, 
};

import svgFacebook from "../../../../../content/svgLoader/svgFile/svgFacebook";
import svgDribbble from "../../../../../content/svgLoader/svgFile/svgDribbble";
import svgPinterest from "../../../../../content/svgLoader/svgFile/svgPinterest";
import svgTelegram from "../../../../../content/svgLoader/svgFile/svgTelegram";
import svgWhatsapp from "../../../../../content/svgLoader/svgFile/svgWhatsapp";
import svgInstagram from "../../../../../content/svgLoader/svgFile/svgInstagram";
import svgGithub from "../../../../../content/svgLoader/svgFile/svgGithub";
import svgTiktok from "../../../../../content/svgLoader/svgFile/svgTiktok";
import svgEmail from "../../../../../content/svgLoader/svgFile/svgEmail";
import svgLocation from "../../../../../content/svgLoader/svgFile/svgLocation";
import svgEitaa from "../../../../../content/svgLoader/svgFile/pr/svgEitaa";
import svgSoroush from "../../../../../content/svgLoader/svgFile/pr/svgSoroush";
import svgBale from "../../../../../content/svgLoader/svgFile/pr/svgBale";
import svgLinkedin from "../../../../../content/svgLoader/svgFile/svgLinkedin";
import svgLinkedinCo from "../../../../../content/svgLoader/svgFile/svgLinkedinCo.vue"
import svgAparat from "../../../../../content/svgLoader/svgFile/pr/svgAparat";
import svgGap from "../../../../../content/svgLoader/svgFile/pr/svgGap";
import svgDivar from "../../../../../content/svgLoader/svgFile/pr/svgDivar";
import svgSheypour from "../../../../../content/svgLoader/svgFile/pr/svgSheypour";
import svgTwitter from "../../../../../content/svgLoader/svgFile/svgTwitter";
import svgSkype from "../../../../../content/svgLoader/svgFile/svgSkype";
import svgYoutube from "../../../../../content/svgLoader/svgFile/svgYoutube";
import svgWechat from "../../../../../content/svgLoader/svgFile/svgWechat";
import svgViber from "../../../../../content/svgLoader/svgFile/svgViber";
import svgRubika from "../../../../../content/svgLoader/svgFile/pr/svgRubika";
import svgDigikala from "../../../../../content/svgLoader/svgFile/pr/svgDigikala.vue";
import svgBasalam from "../../../../../content/svgLoader/svgFile/pr/svgBasalam.vue"
import svgSnappshop from "../../../../../content/svgLoader/svgFile/pr/svgSnappshop";
import svgTechnolife from "../../../../../content/svgLoader/svgFile/pr/svgTechnolife";
import svgTorob from "../../../../../content/svgLoader/svgFile/pr/svgTorob";
import svgEmalls from "../../../../../content/svgLoader/svgFile/pr/svgEmalls";
import SvgBase from "@/view/content/svgLoader/svgBase";
import svgCafebazaar from "../../../../../content/svgLoader/svgFile/pr/svgCafebazaar.vue";
import svgGoogleplay from "../../../applicaion/cm/svgGoogleplay.vue";
import svgApple from "../../../applicaion/cm/svgAppstore.vue"
import svgSamsung from "../../../applicaion/cm/svgSamsungstore.vue";

export default {
  name: "SocialListGrouped",

  components: {
    SvgBase,
    svgFacebook, svgDribbble, svgPinterest, svgTelegram, svgWhatsapp, svgInstagram,
    svgGithub, svgTiktok, svgEmail, svgLocation, svgEitaa, svgSoroush, svgBale,
    svgLinkedin, svgAparat, svgGap, svgDivar, svgSheypour, svgTwitter, svgSkype,
    svgYoutube, svgWechat, svgViber, svgRubika, svgDigikala, svgBasalam,
    svgSnappshop, svgTechnolife, svgTorob, svgEmalls, svgCafebazaar, 
    svgGoogleplay, svgApple, svgSamsung,svgLinkedinCo
  },  
  props: {
    medias: { type: Array, required: true },
    value: { type: Object, required: true },
    getSocialColor: { type: Function, required: true },
    hexToRgba: { type: Function, required: true }
  },
  
  data() {
    return {
      isListExpanded: false,
      initialLimit: 4
    };
  },

  computed: {
    groupedMediasArray() {
      const groups = {};
      this.medias.forEach(item => {
        const key = item.name; 
        
        const config = socialConfig[key] || { 
          svg: item.svg, 
          color: this.getSocialColor(key) || '#4a90e2',
          viewBox: 50 
        };
        
        if (!groups[key]) {
          groups[key] = {
            name: key,
            svg: config.svg,
            color: config.color,
            viewBox: config.viewBox, 
            items: []
          };
        }
        groups[key].items.push(item);
      });
      return Object.values(groups);
    },
    displayedGroups() {
      if (this.isListExpanded) {
        return this.groupedMediasArray;
      }
      return this.groupedMediasArray.slice(0, this.initialLimit);
    }
  }
};
</script>

<style lang="scss" scoped>
.social-groups-wrapper {
  display: flex;
  flex-direction: column;
  gap: 12px;
  width: 100%;
  padding: 10px 2px;
  box-sizing: border-box;
  border-radius: 16px;
}

.group-card {
  display: flex;
  flex-direction: row;
  align-items: stretch;
  width: 100%;
  min-height: 64px;
  border-radius: 12px;
  overflow: hidden;
  background: rgba(255, 255, 255, 0.1);
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.1);
  position: relative;
}

.group-header {
  display: flex;
  flex-direction: row;
  align-items: center;
  min-width: 60px;
  background: rgba(255, 255, 255, 0.05);
  border-left: 1px solid rgba(255, 255, 255, 0.15);
}

.color-indicator {
  width: 6px;
  height: 100%;
  border-radius: 0 12px 12px 0;
}

.main-icon-wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
  flex: 1;
  padding: 0 10px;

  /* بهبود استایل برای فیت شدن کامل آیکون‌ها */
  ::v-deep svg {
    width: 28px;
    height: 28px;
    max-width: 100%;
    max-height: 100%;
    object-fit: contain;
    display: block;
  }
}

.group-links {
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding: 8px 12px;
  gap: 6px;
}

.link-item {
  display: inline-block;
  cursor: pointer;
  text-decoration: none;
  padding: 4px 8px;
  background: rgba(255, 255, 255, 0.1);
  border-radius: 6px;
  border: 1px solid rgba(255, 255, 255, 0.2);
  transition: all 0.2s;
  text-align: start;
  color: inherit; 
  
  &:hover {
    background: rgba(255, 255, 255, 0.2);
    border-color: rgba(255, 255, 255, 0.4);
  }

  .link-text {
    font-size: 0.85rem;
    color: inherit; 
    word-break: break-all;
  }
}

/* استایل‌های مربوط به دکمه نمایش بیشتر/کمتر */
.toggle-container {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 12px;
  padding: 0 8px;

  .divider-line {
    flex: 1;
    height: 1px;
    background: linear-gradient(90deg, rgba(255, 255, 255, 0) 0%, rgba(255, 255, 255, 0.4) 50%, rgba(255, 255, 255, 0) 100%);
  }

  .toggle-btn {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 4px;
    padding: 6px 16px;
    border-radius: 20px;
    font-size: 0.8rem;
    font-weight: 500;
    color: #ffffff;
    background: rgba(255, 255, 255, 0.15);
    cursor: pointer;
    transition: all 0.3s ease;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);

    &:hover {
      background: rgba(255, 255, 255, 0.25);
      transform: translateY(-2px);
    }
    
    span {
      margin-top: 2px;
    }
  }
}

.glass-effect {
  backdrop-filter: blur(12px) !important;
  -webkit-backdrop-filter: blur(12px) !important;
  border: 1px solid rgba(255, 255, 255, 0.2) !important;
}
</style>
